import { render } from "./CampaignsBanner.vue?vue&type=template&id=14d66465"
import script from "./CampaignsBanner.vue?vue&type=script&lang=js"
export * from "./CampaignsBanner.vue?vue&type=script&lang=js"

import "./CampaignsBanner.vue?vue&type=style&index=0&id=14d66465&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__